import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import toast from "react-hot-toast";
import { GetCart } from "../apis/Api";
import { useNavigate, useParams } from "react-router-dom";
import CartItem from "../components/Cart/CartItem";
import BreadScrumb from "../components/BreadScrumb";

const CartSummary = () => {
  const [devices, setDevices] = useState([]);
  const [address, setAddress] = useState([]);
  const [totalPrice, setTotalPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(0);

  const { brand_token, model_token } = useParams();
  const navigate = useNavigate();
  console.log(totalPrice);
  useEffect(() => {
    fetchDevices();
  }, [updateTrigger]);

  const fetchDevices = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("no user found");
      }

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000)
      );

      const responsePromise = GetCart({
        cust_token: token,
        brand_token,
        model_token,
      });
      const response = await Promise.race([responsePromise, timeoutPromise]);
      // console.log(response);
      if (response && response.data) {
        setDevices(response.data);
        const addres = JSON.parse(response.data[0].order.address);
        setAddress(addres);
        setTotalPrice(response.data[0].order.total_price);
      }
    } catch (error) {
      console.log(error, "hello");
      if (error.status === 404) {
        setError("No orders found. Please add items to your cart.");
        navigate("/");
        return;
      }

      console.log("Error fetching devices:", error);
      setError(error.message || "Failed to load orders. Please try again.");
      setDevices([]);
      toast.error(`${error.message}`);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <BreadScrumb
          title="Cart Summary"
          Banner="/assets/images/background/3.webp"
        />
        <CartItem
          loading={loading}
          setLoading={setLoading}
          refreshing={refreshing}
          setRefreshing={setRefreshing}
          error={error}
          setError={setError}
          fetchDevices={fetchDevices}
          devices={devices}
          setDevices={setDevices}
          address={address}
          totalPrice={totalPrice}
          updateTrigger={updateTrigger}
          setUpdateTrigger={setUpdateTrigger}
        />
      </div>

      <Footer />
    </div>
  );
};

export default CartSummary;
